import { Project } from "../../../../models/Project";
import { Organization } from "../../../../models/Organization";
import React, { useContext, useState } from "react";
import { ApiClient } from "../../../../client/ApiClient";
import { useRevalidator } from "react-router-dom";
import { SnackbarContext } from "../../../../components/Snackbar/SnackbarProvider";
import { Box, Switch, useTheme } from "@mui/material";
import { Width } from "../../../../const/Width";
import { SettingsSwitchOptionWrapper } from "../../../../components/form/OptionsWrapper";
import { SettingsHead } from "../../../../components/form/SettingsHead";
import { FormButtons } from "../../../../components/form/FormButtons";

interface Props {
  organization: Organization
  project: Project
}

interface State {
  enabled: boolean
}

export const SecurityNotifications = (props: Props) => {
  const theme = useTheme()
  const { organization, project } = props
  const [loading, setLoading] = useState(false)
  const [state, setState] = useState<State>({ enabled: project.security_notifications?.notifications?.email_create?.enabled ?? false })
  const revalidator = useRevalidator()
  const { error, success } = useContext(SnackbarContext)

  const onChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState({
      ...state,
      [e.target.name]: e.target.checked
    })
  }

  const onSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      await ApiClient.updateProject(organization.id, project.id, {
        security_notifications: {
          ...project.security_notifications,
          notifications: {
            password_update: { enabled: state.enabled },
            primary_email_update: { enabled: state.enabled },
            email_create: { enabled: state.enabled },
            email_delete: { enabled: state.enabled },
            passkey_create: { enabled: state.enabled },
            mfa_create: { enabled: state.enabled },
            mfa_delete: { enabled: state.enabled },
          }
        }
      })
      success("Settings updated")
      revalidator.revalidate()
    } catch (e) {
      error("Failed to update settings")
    }
    setLoading(false)
  }

  const onCancel = () => {
    setState({ enabled: project.security_notifications?.notifications?.email_create?.enabled ?? false })
  }

  const somethingChanged = () => {
    return state.enabled !== (project.security_notifications?.notifications?.email_create?.enabled ?? false)
  }

  return <Box maxWidth={Width.NORMAL}>
    <form onSubmit={onSubmit}>
      <SettingsSwitchOptionWrapper sx={{
        borderBottom: `1px solid ${theme.palette.grey["900"]}`
      }}>
        <SettingsHead title="Security Notifications"
                      description="Enable security notifications to inform users whenever their login credentials change." sx={{ mb: 1 }} />
        <Switch name="enabled" color="success" checked={state.enabled}
                onChange={onChecked} />
      </SettingsSwitchOptionWrapper>
      <FormButtons onCancel={onCancel} loading={loading} disabled={!somethingChanged()} />
    </form>
  </Box>
};